// 火车票
const trainRouter = [
  {
    // 列表页面
    path: '/trainIndex',
    name: 'trainIndex',
    component: () => import('@/page/train/trainIndex')
  },
  {
    // 订单填写页面
    path: '/trainOrderFill',
    name: 'trainOrderFill',
    component: () => import('@/page/train/trainOrderFill')
  },
  {
    // 订单确认页面
    path: '/trainOrderConfirm',
    name: 'trainOrderConfirm',
    component: () => import('@/page/train/trainOrderConfirm')
  },
  {
    // 订单预订成功页面
    path: '/trainBookSuccess',
    name: 'trainBookSuccess',
    component: () => import('@/page/train/trainBookSuccess')
  }
]
export default trainRouter



// WEBPACK FOOTER //
// ./src/router/modules/train.js